export default {
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات أمان أخرى"])}
}